import type { ReactElement } from "react";
import { type BoxProps, Column, MotionBox } from "@hightouch/htui";
import { motion } from "motion/react";
import { useShimmer } from "./use-shimmer";

interface Props
  extends Omit<
    BoxProps,
    "transition" | "onDrag" | "onDragStart" | "onDragEnd" | "onAnimationStart"
  > {
  children: ReactElement[];
}

const staggeredAnimation = {
  animate: {
    transition: {
      staggerChildren: 0.1, // 0.1 seconds between each child
    },
  },
};

const MotionColumn = motion.create(Column);

export const SkeletonList = ({ children, ...props }: Props) => {
  const shimmer = useShimmer();

  return (
    <MotionColumn {...props} animate="animate" variants={staggeredAnimation}>
      {children.map((child, i) => (
        <MotionBox key={i} {...child.props} variants={shimmer}>
          {child}
        </MotionBox>
      ))}
    </MotionColumn>
  );
};
